// extracted by mini-css-extract-plugin
module.exports = {"jcGrey200":"#e3e8e9","card":"Card__card"};